'use client';
import React, { MouseEventHandler, ReactHTMLElement, useEffect } from 'react';

interface ModalProps {
  children: React.ReactNode;
  open: boolean;
  className?: string;
}

const Modal: React.FC<ModalProps> = ({ children, open = true, className = '', ...props }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center w-screen h-screen bg-black/50">
      <div className={`relative bg-white rounded-lg shadow-lg ${className}`} {...props}>
        {children}
      </div>
    </div>
  );
};

export default Modal;
